module.exports = __webpack_public_path__ + "media/images/menu/edit-838911668a524e0703cfb373562becf8.svg";